import schemas from 'components/forms/fields/definedSchemas';
import Joi from 'joi';

const fields = {
    user_document_post_response: {
        component: 'ImageSelect',
        label: 'Upload Images',
        name: 'user_document_post_response',
        section: 'Add Images',
    },
    date_reported: {
        ...schemas.dateRequiredMaxToday,
        label: 'What is the start date on the AOPS?',
        review_label: 'Start Date',
        section: 'Your Info',
    },
    date_detached: {
        ...schemas.dateRequiredMaxToday,
        label: 'What is the end date on the AOPS?',
        review_label: 'End Date',
        section: 'Your Info',
        validation: schemas.dateRequiredMaxToday.validation
            .min(Joi.ref('date_reported'))
            .messages({
                'date.min': "Date detached can't be before date reported.",
            }),
    },
    rank_type: {
        component: 'RankRating',
        label: 'Rank Type',
        name: 'rank_type',
        section: 'RankRating',
    },
    rank_E: {
        component: 'RankRating',
        label: 'Rank',
        name: 'rank_E',
        section: 'RankRating',
    },
    rank_CWO: {
        component: 'RankRating',
        label: 'Rank',
        name: 'rank_CWO',
        section: 'RankRating',
    },
    rank_O: {
        component: 'RankRating',
        label: 'Rank',
        name: 'rank_O',
        section: 'RankRating',
    },
    rating: {
        component: 'RankRating',
        label: 'Rating',
        name: 'rating',
        section: 'RankRating',
    },

    aops_uscg_uw_hours_total: {
        component: 'Competency',
        label: 'Grand Total U/W Hours on AOPS',
        review_label: 'Total U/W Hours',
        name: 'aops_uscg_uw_hours_total',
        section: 'Competency',
    },
    _position_listed: {
        component: 'Competency',
        label: 'Does your AOPS have Coxswain or Engineer listed under Position/Competency?',
        name: '_position_listed',
        section: 'Competency',
    },
    aops_uscg_uw_hours_coxswain: {
        component: 'Competency',
        description: 'Position: Coxswain',
        label: 'Add your hours from each entry',
        name: 'aops_uscg_uw_hours_coxswain',
        section: 'Competency',
    },
    aops_uscg_uw_hours_engineer: {
        component: 'Competency',
        description: 'Position: Engineer',
        label: 'Add your hours from each entry',
        name: 'aops_uscg_uw_hours_engineer',
        section: 'Competency',
    },
    watertype: {
        component: 'Competency',
        label: 'We know route is not on your AOPS, but it makes your life easier if you select where you were working while U/W',
        name: 'watertype',
        section: 'Competency',
    },
};

export default fields;
